import { api } from '../services/api'

export const getConstants = () => {
	return (dispatch) => {
		dispatch({ type: 'GET_CONSTANTS' })
		return api
			.get('/constants')
			.then((response) => {
				dispatch({ type: 'GET_CONSTANTS_SUCCESS', payload: response.data })
			})
			.catch(() => {
				dispatch({ type: 'GET_CONSTANTS_FAIL' })
			})
	}
}

export const getApartments = (marketId) => {
	return (dispatch) => {
		dispatch({ type: 'GET_APARTMENTS' })
		return api
			.get(`/apartments/${marketId}`)
			.then((response) => {
				dispatch({ type: 'GET_APARTMENTS_SUCCESS', payload: response.data })
			})
			.catch(() => {
				dispatch({ type: 'GET_APARTMENTS_FAIL' })
			})
	}
}
